module.exports = __webpack_public_path__ + "img/delete.1f64e2e0.svg";